<template>
  <v-app>
    <component :is="layout" />
  </v-app>
</template>

<script>
const defaultLayout = "LayoutsDefault";
import { defineComponent } from "vue";
import LayoutsDefault from "../src/components/layouts/default.vue";
import LayoutsMain from "../src/components/layouts/main.vue";

export default defineComponent({
  name: "App",
  components: {
    LayoutsDefault,
    LayoutsMain,
  },
  data: () => ({}),
  computed: {
    layout() {
      return this.$route.meta.layout || defaultLayout;
    },
  },
});
</script>
<style>
@font-face {
  font-family: phetsarath ot;
  src: url("~@/assets/fonts/Phetsarath_OT.ttf") format("truetype");
}
.swal2-popup {
  font-size: 14px !important;
  font-family: phetsarath ot, serif;
}
h2#swal2-title
{
  font-family: phetsarath ot, serif;
}
div#swal2-html-container{
  font-family: phetsarath ot, serif;
}
</style>